import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_promotions_code_lookup_integration_settings: { message: "idle" },
};

export const retrieve_tenant_promotions_code_lookup_integration_settings_Slice = createSlice({
 name: "retrieve_tenant_promotions_code_lookup_integration_settings",
 initialState,
 reducers: {
  success_retrieve_tenant_promotions_code_lookup_integration_settings: (state, action) => {
   state.retrieve_tenant_promotions_code_lookup_integration_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_promotions_code_lookup_integration_settings: (state, action) => {
   state.retrieve_tenant_promotions_code_lookup_integration_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_promotions_code_lookup_integration_settings: (state) => {
   state.retrieve_tenant_promotions_code_lookup_integration_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_promotions_code_lookup_integration_settings: (state) => {
   state.retrieve_tenant_promotions_code_lookup_integration_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_promotions_code_lookup_integration_settings, fail_retrieve_tenant_promotions_code_lookup_integration_settings, reset_retrieve_tenant_promotions_code_lookup_integration_settings, loading_retrieve_tenant_promotions_code_lookup_integration_settings } = retrieve_tenant_promotions_code_lookup_integration_settings_Slice.actions;

export default retrieve_tenant_promotions_code_lookup_integration_settings_Slice.reducer;